export default {
    namespaced: true,

    state: {
        location: {},
        deliveries: [],
        pickupPoints: [],
        stores: [],
        storesCount: 0,
        pickupPointsCount: 0,
        skipMinAmountFilter: false,
        pickupPointsModal: false,
        withSelectButton: false,
        mapSettings: {
            apiKey: '1a945905-5963-4046-8eb5-808fe9157194',
            lang: 'ru_RU',
            coordorder: 'latlong',
            enterprise: false,
            version: '2.1'
        }
    },

    getters: {
        deliveryMethodHasPickupPoints: (state) => (deliveryMethodId) => {
            return deliveryMethodId === 2;
        },

        deliveryMethods (state) {
            return _.uniq(state.deliveries.map(item => item.delivery_method_id));
        },

        services: (state) => (methodId, regionId, cityId) => {
            return _.uniq(
                state.deliveries.filter(delivery => delivery.delivery_method_id === methodId
                    && delivery.region_id === regionId
                    && (delivery.city_id === cityId || delivery.city_id === null)
                ).map(item => item.delivery_service_id));
        },

        locationDeliveries: (state) => (regionId, cityId) => {
            let deliveries = _.orderBy(state.deliveries, ['region', 'city'], ['asc', 'desc'])
                .filter(item => item.region_id === regionId);

            let filteredDeliveries = [];

            for (let i in deliveries) {
                if (! filteredDeliveries.filter(function (item) {
                    return item.delivery_method_id === deliveries[i].delivery_method_id
                        && item.delivery_service_id === deliveries[i].delivery_service_id
                }).length) {
                    filteredDeliveries.push(deliveries[i]);
                }
            }

            return filteredDeliveries;
        },

        payments: (state, getters, rootState, rootGetters) => (methodId, serviceId, regionId, cityId) => {
            let deliveries = _.orderBy(state.deliveries, ['region', 'city'], ['asc', 'desc']);

            let delivery = deliveries.find(delivery => delivery.delivery_method_id === methodId
                && delivery.delivery_service_id === serviceId
                && delivery.region_id === regionId
                && delivery.city_id === cityId);

            if (!delivery) {
                delivery = deliveries.find(delivery => delivery.delivery_method_id === methodId
                    && delivery.delivery_service_id === serviceId
                    && delivery.region_id === regionId
                    && delivery.city_id === null);
            }

            if (state.skipMinAmountFilter) {
                return delivery ? delivery.payments : [];
            }

            if (delivery) {
                return delivery.payments;
            }

            return [];
        },

        servicePickupPoints: (state) => (serviceId) => {
            return state.pickupPoints.filter(item => item.delivery_service_id === serviceId);
        },

        deliveryCost: (state, getters) => (methodId, serviceId, regionId, cityId, paymentTypeId) => {
            if (!methodId || !serviceId || !regionId || !paymentTypeId) {
                return false;
            }

            let payments = getters.payments(methodId, serviceId, regionId, cityId);

            let payment = payments.find(item => item.payment_type_id === paymentTypeId);

            if (payment) {
                return payment.cost;
            }

            return false;
        },

        hasPickupPoints (state) {
            return state.pickupPointsCount !== 0 || state.storesCount !== 0;
        },

        pickupPointsCountLabel: (state) => () => {
            if (state.pickupPointsCount === 0 && state.storesCount === 0) {
                return '';
            }

            let label = '',
                lastDigit,
                decimals;

            if (state.storesCount) {
                label += state.storesCount + ' ';

                lastDigit = state.storesCount % 10;
                decimals = ((state.storesCount - lastDigit) / 10) % 10;

                if ((lastDigit === 1) && (decimals !== 1)) {
                    label += 'магазин';
                } else if ((lastDigit > 1) && (lastDigit < 5) && (decimals !== 1)) {
                    label += 'магазина';
                } else {
                    label += 'магазинов';
                }

                if (state.pickupPointsCount) {
                    label += ', ';
                }
            }

            if (state.pickupPointsCount) {
                label += state.pickupPointsCount + ' ';

                lastDigit = state.pickupPointsCount % 10;
                decimals = ((state.pickupPointsCount - lastDigit) / 10) % 10;

                if (state.storesCount) {
                    label += 'ПВЗ'
                } else if ((lastDigit === 1) && (decimals !== 1)) {
                    label += 'пункт выдачи';
                } else if ((lastDigit > 1) && (lastDigit < 5) && (decimals !== 1)) {
                    label += 'пункта выдачи';
                } else {
                    label += 'пунктов выдачи';
                }
            }

            return label;
        },
    },

    mutations: {
        setLocation (state, location) {
            Vue.set(state, 'location', location);
        },

        setDeliveries (state, deliveries) {
            Vue.set(state, 'deliveries', deliveries);
        },

        setPickupPoints (state, pickupPoints) {
            Vue.set(state, 'pickupPoints', pickupPoints);

            Vue.set(state, 'pickupPointsCount', pickupPoints ? pickupPoints.length : 0);
        },

        setStores (state, stores) {
            Vue.set(state, 'stores', stores);

            Vue.set(state, 'storesCount', stores ? stores.length : 0);
        },

        setPickupPointsCount (state, pickupPointsCount) {
            Vue.set(state, 'pickupPointsCount', pickupPointsCount);
        },

        setStoresCount (state, storesCount) {
            Vue.set(state, 'storesCount', storesCount);
        },

        addDeliveries (state, deliveries) {
            Vue.set(state, 'deliveries', deliveries);
        },

        skipMinAmountFilter (state) {
            state.skipMinAmountFilter = true;
        },

        showPickupPointsModal (state, withSelectButton) {
            state.withSelectButton = withSelectButton;

            state.pickupPointsModal = true;
        },

        hidePickupPointsModal (state) {
            state.pickupPointsModal = false;
        }
    },
}
